module.exports = require("querystring");


//////////////////
// WEBPACK FOOTER
// external "querystring"
// module id = querystring
// module chunks = 0